import { useReportingAccountType } from "components/reportingFilter/ReportingFilterRequests";
import { useAddOnQuery } from "./useAddOnQuery";
import { AddOnIds } from "enums";

export const useAccountFilterShouldShow = (
  accountId: number,
  _accountType: number,
  supportsSPType?: boolean,
): boolean | undefined => {
  const reportingAccountType = useReportingAccountType(accountId, supportsSPType);
  const addOnsQuery = useAddOnQuery(accountId);

  // Return undefined while still loading
  if (reportingAccountType === undefined || addOnsQuery.isLoading) {
    return undefined;
  }

  const hasCreateAccountsAddOn =
    addOnsQuery.data?.some((addon) => addon.id === AddOnIds.CreateAccounts && addon.isEnabled) ?? false;

  // Show when SP/BSI (non-"account") OR when CreateAccounts add-on is enabled
  return reportingAccountType !== "account" || hasCreateAccountsAddOn;
};
